/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auto_CorrectInputs */

const en_auto_correct = /** @type {(inputs: Auto_CorrectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Auto Correct`)
};

const fr_auto_correct = /** @type {(inputs: Auto_CorrectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Correction automatique`)
};

const de_auto_correct = /** @type {(inputs: Auto_CorrectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Automatische Korrektur`)
};

const it_auto_correct = /** @type {(inputs: Auto_CorrectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Correzione automatica`)
};

const ru_auto_correct = /** @type {(inputs: Auto_CorrectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Автокоррекция`)
};

const es_auto_correct = /** @type {(inputs: Auto_CorrectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Corrección automática`)
};

const zh_cn2_auto_correct = /** @type {(inputs: Auto_CorrectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`自动更正`)
};

const ja_auto_correct = /** @type {(inputs: Auto_CorrectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`自動修正`)
};

const hi_auto_correct = /** @type {(inputs: Auto_CorrectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ऑटो करेक्ट`)
};

const pt_pt2_auto_correct = /** @type {(inputs: Auto_CorrectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Correção automática`)
};

/**
* | output |
* | --- |
* | "Auto Correct" |
*
* @param {Auto_CorrectInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const auto_correct = /** @type {((inputs?: Auto_CorrectInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auto_CorrectInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_auto_correct(inputs)
	if (locale === "de") return de_auto_correct(inputs)
	if (locale === "it") return it_auto_correct(inputs)
	if (locale === "ru") return ru_auto_correct(inputs)
	if (locale === "es") return es_auto_correct(inputs)
	if (locale === "zh-CN") return zh_cn2_auto_correct(inputs)
	if (locale === "ja") return ja_auto_correct(inputs)
	if (locale === "hi") return hi_auto_correct(inputs)
	if (locale === "pt-PT") return pt_pt2_auto_correct(inputs)
	return en_auto_correct(inputs)
});